import { IFiveVariantXP } from '../../indigofair/settings/IFiveVariantXP';
import { SettingConst } from '../../types';

/**
 * Test signup CTA copy on the mobile and desktop headers
 */
export const HEADER_NAV_SIGNUP_CTA_COPY_120224 =
  'HEADER_NAV_SIGNUP_CTA_COPY_120224' as SettingConst<
    'HEADER_NAV_SIGNUP_CTA_COPY_120224',
    keyof typeof IFiveVariantXP.Bucket,
    'RETAILER'
  >;
